import { render, staticRenderFns } from "./infoMenu.vue?vue&type=template&id=f6643fe2&scoped=true&"
import script from "./infoMenu.vue?vue&type=script&lang=js&"
export * from "./infoMenu.vue?vue&type=script&lang=js&"
import style0 from "./infoMenu.vue?vue&type=style&index=0&id=f6643fe2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6643fe2",
  null
  
)

export default component.exports